var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-page__container"},[_vm._v("\n    "+_vm._s(_vm._f("capitalize")(_vm.$t(_vm.message)))+"\n    "),_vm._t("default"),_vm._v(" "),_c('StaticLink',{attrs:{"path":"help-url","label":"help"}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70b4ef76","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/modules/shared/info/InfoContainer.vue
// module id = 1236
// module chunks = 0